<template>
  <!-- If resource type is not "Image",
       or resource type is "Image" but no image exists,
       adjust the icon based on the adjustIcon method -->
  <router-link :to="{ name: 'resourceView', params: { id: resource.id }}">
    <b-card class="mb-1 resource-card card-img-top"
            img-alt="Image"
            img-top
            no-body
            style="max-width: 20rem; min-height: 20rem;"
            tag="div"
            v-if="resource.mediaType !== 'Image' || (resource.mediaType === 'Image' && !resource.url)"
    >
      <div class="bg-gray p-5 m-0 banner-fill" v-if="resource.mediaType !== 'Image'">
    <span :style="adjustColor(resource.mediaType)">
      <font-awesome-icon :icon="adjustIcon(resource.mediaType)"
                         size="5x">
      </font-awesome-icon>
    </span>
      </div>
      <b-card-body>
        <b-card-title>
          <router-link :title="resource.title" :to="{ name: 'resourceView', params: { id: resource.id }}"
                       class="text-dark card-text" v-b-tooltip.hover.bottom>
            {{ resource.title | truncate(55, '...') }}
          </router-link>
        </b-card-title>
      </b-card-body>
    </b-card>
    <!-- If the resource type is "Image",
         load the corresponding image from the resource.url field -->
    <b-card :img-src="resource.url"
            class="mb-1 resource-card card-img-top"
            img-alt="Image"
            img-top
            no-body
            style="max-width: 20rem; min-height: 20rem;"
            tag="div"
            v-else>
      <b-card-body>
        <b-card-title>
          <router-link :title="resource.title" :to="{ name: 'resourceView', params: { id: resource.id }}"
                       class="text-dark card-text" v-b-tooltip.hover.bottom>
            {{ resource.title | truncate(55, '...') }}
          </router-link>
        </b-card-title>
      </b-card-body>
    </b-card>
  </router-link>
</template>

<script>
export default {
  name: 'FeaturedIngredientsCard',
  props: {
    'resource': Object
  },
  methods: {
    adjustIcon (mediaType) {
      // load the proper icon given the media type
      if (mediaType === 'Image') {
        return 'image'
      } else if (mediaType === 'Audio') {
        return 'file-audio'
      } else if (mediaType === 'Linked Video') {
        return 'play-circle'
      } else if (mediaType === 'Website') {
        return 'link'
      } else if (mediaType === 'Text') {
        return 'file-alt'
      } else if (mediaType === 'Pdf') {
        return 'file-pdf'
      } else {
        return 'file-alt'
      }
    },
    adjustColor (mediaType) {
      // load the proper icon given the media type
      if (mediaType === 'Image') {
        return 'image'
      } else if (mediaType === 'Audio') {
        return 'color: #f0d6f1'
      } else if (mediaType === 'Linked Video') {
        return 'color: #ff6c6c'
      } else if (mediaType === 'Website') {
        return 'color: #95c9ff'
      } else if (mediaType === 'Text') {
        return 'color: #fff37a'
      } else if (mediaType === 'Pdf') {
        return 'color: red'
      } else {
        return 'color: #fff37a'
      }
    }
  }
}
</script>

<style scoped>
  .resource-card {
    height: 260px;
  }
  .card-img-top {
    width: 100%;
    height: 180px;
    object-fit: cover;
  }
  .card-text {
      font-size: 20px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/resources/FeaturedIngredientsCard.vue